module.exports = __webpack_public_path__ + "img/argoslogo.6722f8d5.png";